// import { Tooltip, GlobalStyles } from '@mui/material';
// import { keyframes } from '@emotion/react';
// import { getSessionStorageData } from '../functions/get_total_alarms_counts_function';
// import Fade from '@mui/material/Fade';
// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(-10px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;
// export const CustomTooltip = ({ title, children }) => {
//   const sessionData = getSessionStorageData(title);
//   const tooltipContent = `${title} ${sessionData ? `: ${sessionData}` : ''}`;
//   return (
//     <>
//       <GlobalStyles styles={{ '.MuiTooltip-tooltip': { zIndex: 9999 } }} />

//       <Tooltip
//         title={tooltipContent}
//         arrow
//         placement="right"
//         slots={{
//           transition: Fade,
//         }}
//         slotProps={{
//           transition: { timeout: 600 },
//         }}
//         componentsProps={{
//           tooltip: {
//             sx: {
//               bgcolor: '#BD1D23',
//               color: 'white',
//               fontSize: '1em',
//               zIndex: 9999,
//             },
//           },
//           arrow: {
//             sx: {
//               color: '#BD1D23',
//             },
//           },
//         }}
//       >
//         {children}
//       </Tooltip>
//     </>
//   );
// };

import { Tooltip, GlobalStyles } from '@mui/material';
import { getSessionStorageData } from '../functions/get_total_alarms_counts_function';
import Fade from '@mui/material/Fade';

export const CustomTooltip = ({ title, children }) => {
  const sessionData = getSessionStorageData(title);
  const tooltipContent = `${title}${sessionData ? `: ${sessionData}` : ''}`;

  return (
    <>
      <GlobalStyles
        styles={{
          '.MuiTooltip-tooltip': {
            zIndex: 9999,
          },
          '.MuiTooltip-tooltipPlacementRight': {
            marginLeft: '4px', // reduce default spacing to fix gap
          },
        }}
      />

      <Tooltip
        title={tooltipContent}
        arrow
        placement="right"
        slots={{
          transition: Fade,
        }}
        slotProps={{
          transition: { timeout: 600 },
        }}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: '#f2696e',
              color: 'white',
              fontSize: '1em',
              zIndex: 9999,
            },
          },
          arrow: {
            sx: {
              color: '#f2696e',
            },
          },
        }}
      >
        {children}
      </Tooltip>
    </>
  );
};
